import {
    createMultiPickerComponent,
    IMultiPickerBusinessLogic,
    MultiPicker,
} from '@vfde-brix/multi-picker';
import { IInitialState } from 'Container/Landingpage/types';
import { IOfferKeyElements } from '../offerDataHelper';

/**
 * Types to define the kind of multipicker. We have two different kinds
 * on gigakombi landingpage:
 * - User selects what he has
 * - User selects what he wants
 */
export type GigakombiMultipickerType = 'has' | 'wants';

const updateMultipickerComponent = (multiPickerComponent: MultiPicker, offerIdElements: IOfferKeyElements) => {
    const properties = multiPickerComponent.getProperties();
    const { items } = properties;

    items.forEach(multipickerOption => {
        multipickerOption.checked = offerIdElements[multipickerOption.stdValue];
    });
    multiPickerComponent.update(properties);
};

/**
 * Multi-Picker BRIX component
 * @param action
 * @param container
 */
export const mountMultiPicker = (action, container: string) => {

    const elMultiPicker = document.getElementById(container);
    const businessLogicProps: IMultiPickerBusinessLogic = {
        onChange: (event: Event) => {
            selectOption(event);
        },
    };

    // No props because we need to read the option tabs from DOM first
    const multiPicker = createMultiPickerComponent(elMultiPicker, businessLogicProps);

    const selectOption = (event) => {
        return action(event.target.value, event.target.checked);
    };

    return multiPicker;
};

/**
 * Updates Multipicker
 * @param multiPickerComponent (User Has)
 * @param multiPickerComponent (User Wants)
 * @param state
 */
export const updateMultipicker = (multiPickerComponentHas: MultiPicker, multiPickerComponentWants: MultiPicker, offerIdElements: IOfferKeyElements) => {

    updateMultipickerComponent(multiPickerComponentHas, offerIdElements);

    updateMultipickerComponent(multiPickerComponentWants, offerIdElements);

};

/**
 * Updates Multipicker
 * @param multiPickerComponent
 * @param param_preselect
 * @param multipickerType
 */
export const adjustMultipickerHas = (multiPickerComponent: MultiPicker, state: IInitialState) => {
    const offerIdElements: IOfferKeyElements = {
        has_mobilfunk: state.has_mobilfunk,
        has_internet: state.has_internet,
        has_tv: state.has_tv,
        has_none: state.has_none,
        wants_mobilfunk: state.wants_mobilfunk,
        wants_internet: state.wants_internet,
        wants_tv: state.wants_tv,
        wants_redplus: state.wants_redplus,
    };
    updateMultipickerComponent(multiPickerComponent, offerIdElements);
};
